module.exports = __webpack_public_path__ + "img/ico_settings.f4660d0c.svg";